export const compositionModelSeries = [
    "Премиум",
]
